import type { OrderDoc, TitleDoc } from '@/types/platform';

export type DigitalSaleState = 'available' | 'coming-soon' | 'preorder';
export type SaleTitle = Pick<TitleDoc, 'digitalSaleState' | 'availableDigitalFormats' | 'preorderFormats'>;
export const PREORDER_NOTICE = 'Pre-order: charged now. Your selected format will be delivered to your account, with an email download link, only when the owner releases this book.';

export function digitalSaleState(title: SaleTitle): DigitalSaleState {
  return title.digitalSaleState || 'available';
}

export function saleFormats(title: SaleTitle) {
  if (digitalSaleState(title) === 'coming-soon') return [];
  return [...new Set((digitalSaleState(title) === 'preorder' ? title.preorderFormats : title.availableDigitalFormats) || [])]
    .filter((format): format is 'epub' | 'pdf' => format === 'epub' || format === 'pdf');
}

export function awaitingRelease(line: NonNullable<OrderDoc['lineItems']>[number]) {
  return line.deliveryPromise === 'admin-release' && !line.releaseId;
}

export function orderAwaitsRelease(order: Pick<OrderDoc, 'lineItems'>) {
  return Boolean(order.lineItems?.some(awaitingRelease));
}

export function deliveryLabel(line: NonNullable<OrderDoc['lineItems']>[number]) {
  return awaitingRelease(line) ? 'Paid — awaiting owner release' : line.releaseId ? 'Released — available in your account' : 'Available in your account';
}

export function accountCanReceiveRelease(user: Record<string, unknown> | undefined) {
  return Boolean(user && !user.privacySubjectDeleted && !user.adminDeletionId && !user.privacyDeletionPendingAt && !['disabled', 'on_hold', 'suspended'].includes(String(user.accountStatus || 'active')));
}
